<div class="profile-page-wrapper">
    <ng-container>
        <app-header></app-header>
    </ng-container>
    <ng-container>
        <app-breadcrumb-nav [breadCrumbData]="breadCrumbData"></app-breadcrumb-nav>
    </ng-container>
  <div class="d-block d-sm-none" >
    <div class="mobile-header-bar" [ngClass]="{'green-tier': tierType === 'green' || (tierType === 'welcome' && isLoggedInUser),'gold-tier': tierType === 'gold' || (tierType === 'welcome' && !isLoggedInUser)}">
      <div class="left" [routerLink]="['/ordering']">
        <img *ngIf="tierType === 'gold'" src="assets/icon/bck.svg" alt="back">
        <img *ngIf="tierType === 'green' || (tierType === 'welcome' && isLoggedInUser) " src="assets/icon/bck-white.svg" alt="back" />
        <img *ngIf="tierType === 'welcome' && !isLoggedInUser" src="assets/icon/bck.svg" alt="back">
      </div>
      <div class="title">
        <p [ngClass]="{'nopd':tierType === 'welcome' && !isLoggedInUser}">Account</p>
      </div>
      <div class="right">
        <div *ngIf="isLoggedInUser">
            <img class="me-3" *ngIf="tierType === 'gold' && viewData?.unreadNotification == 0" src="assets/icon/notification_icon.svg" alt="notification_icon" [routerLink]="['/profile/notifications']">
            <img class="me-3" *ngIf="tierType === 'gold' && viewData?.unreadNotification > 0" src="assets/icon/notification_icon_unread.svg" alt="notification_icon" [routerLink]="['/profile/notifications']">
            <!-- <img *ngIf="tierType === 'gold'" src="assets/icon/settings_icon.svg" alt="settings_icon" [routerLink]="['/profile/settings']"> -->
            <img class="me-3" *ngIf="(tierType === 'green' || tierType === 'welcome') && viewData?.unreadNotification == 0" src="assets/icon/notification_icon_white.svg" alt="notification_icon" [routerLink]="['/profile/notifications']">
            <img class="me-3" *ngIf="(tierType === 'green' || tierType === 'welcome') && viewData?.unreadNotification > 0" src="assets/icon/notification_icon_white_unread.svg" alt="notification_icon" [routerLink]="['/profile/notifications']">
            <!-- <img *ngIf="tierType === 'green' || tierType === 'welcome'" src="assets/icon/settings_icon_white.svg" alt="settings_icon" [routerLink]="['/profile/settings']"> -->
        </div>
        <!-- <div *ngIf="!isLoggedInUser">
            <img src="assets/icon/settings_icon.svg" alt="settings_icon" [routerLink]="['/profile/settings']">
        </div> -->
        </div>
      </div>
  </div>
  <div class="profile-blk mb-9" *ngIf="!showProfileShimmer"
  [ngClass]="{'green-tier': tierType === 'green'|| (tierType === 'welcome' && isLoggedInUser) ,'gold-tier': tierType === 'gold' || (tierType === 'welcome' && !isLoggedInUser), 'mb-9' : !isLoggedInUser ,'mb-30' : isLoggedInUser }">
        <section class="tier-section">
            <span class="left-leaf" *ngIf="tierType === 'green'|| (tierType === 'welcome' && isLoggedInUser)">
                <img src="assets/icon/green-leaf.svg" alt="left-leaf">
            </span>
            <span class="left-leaf" *ngIf="tierType === 'gold' || (tierType === 'welcome' && !isLoggedInUser)">
                <img src="assets/images/leaf_gold.svg" alt="left-leaf">
            </span>
            <div class="container card-tier">
                <div class="row dp-blk">
                    <div class="col-lg-5 col-md-4 col-sm-4 d-none d-sm-block">
                        <img class='back-icon'src="assets/icon/m-back.svg" alt="back"(click)="gotoPrevius()">
                    </div>
                    <div class="col-lg-2 col-md-4 col-sm-4">
                        <div class="group-gap">
                            <div class="avatar-upload">
                                <div class="avatar-preview"
                                    [ngStyle]="{'border-color': tierType === 'green'  ? '#3d764a' : '#cba258'}">
                                    <div id="imagePreview" [style.backgroundImage]="'url('+ imageUrl +')'"></div>
                                </div>
                                <div class="edit-icon" *ngIf="isLoggedInUser">
                                    <img *ngIf="tierType === 'gold'" src="assets/icon/edit_ico.svg" alt="edit_ico"
                                        class="edit_ico" (click)="editProfileGA()" [routerLink]="['/profile/update-profile']">
                                    <!-- <img *ngIf="tierType === 'green' || tierType === 'welcome'"
                                        src="assets/icon/edit-icon-green.svg" alt="edit_ico" class="edit_ico"
                                        (click)="editProfileGA()" [routerLink]="['/profile/update-profile']"> -->
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-5 col-md-4 col-sm-4 d-none d-sm-block text-right icons-set" *ngIf="isLoggedInUser">
                        <img class="me-3" *ngIf="tierType === 'gold' && viewData?.unreadNotification == 0" src="assets/icon/notification_icon.svg" alt="notification_icon" (click)="notificationGA()" [routerLink]="['/profile/notifications']">
                        <img class="me-3" *ngIf="tierType === 'gold' && viewData?.unreadNotification > 0" src="assets/icon/notification_icon_unread.svg" alt="notification_icon" (click)="notificationGA()" [routerLink]="['/profile/notifications']">
                        <!-- <img *ngIf="tierType === 'gold'" src="assets/icon/settings_icon.svg" alt="settings_icon" (click)="settingsGA()" [routerLink]="['/profile/settings']"> -->
                        <img class="me-3" *ngIf="(tierType === 'green' || tierType === 'welcome') && viewData?.unreadNotification == 0" src="assets/icon/notification_icon_white.svg" alt="notification_icon" (click)="notificationGA()" [routerLink]="['/profile/notifications']">
                        <img class="me-3" *ngIf="(tierType === 'green' || tierType === 'welcome') && viewData?.unreadNotification > 0" src="assets/icon/notification_icon_white_unread.svg" alt="notification_icon" (click)="notificationGA()" [routerLink]="['/profile/notifications']">
                        <!-- <img *ngIf="tierType === 'green' || tierType === 'welcome'" src="assets/icon/settings_icon_white.svg" alt="settings_icon" (click)="settingsGA()" [routerLink]="['/profile/settings']"> -->
                    </div>
                    <div class="col-lg-5 col-md-4 col-sm-4 d-none d-sm-block text-right icons-set"  *ngIf="!isLoggedInUser">
                        <img class="me-3" *ngIf="viewData?.unreadNotification == 0" src="assets/icon/notification_icon.svg" alt="notification_icon" (click)="notificationGA()" [routerLink]="['/profile/notifications']">
                        <img class="me-3" *ngIf="viewData?.unreadNotification > 0" src="assets/icon/notification_icon_unread.svg" alt="notification_icon" (click)="notificationGA()" [routerLink]="['/profile/notifications']">
                        <!-- <img src="assets/icon/settings_icon.svg" alt="settings_icon" (click)="settingsGA()" [routerLink]="['/profile/settings']"> -->
                    </div>
                </div>
                <div class="row dp-blk">
                    <div class="col-lg-4 col-md-2"></div>
                    <div class="col-lg-4 col-md-8 content">
                        <div class="" *ngIf="isLoggedInUser">
                            <h2 class="card-title" *ngIf="viewData?.firstName != ''">{{viewData?.firstName}}&nbsp;{{viewData?.lastName}}</h2>
                            <p *ngIf="viewData?.tier != ''">{{viewData?.tier}} Tier</p>
                        </div>
                        <!-- <div class="" *ngIf="!isLoggedInUser">
                            <h2 class="card-title">Welcome to Starbucks</h2>
                            <button type="button" class="custom-btn btn-black btn-lg-rounded mt-2"
                                [routerLink]="['/login']">Login or Sign Up</button>
                        </div> -->
                    </div>
                    <div class="col-lg-4"></div>
                </div>
            </div>
            <span class="right-leaf" *ngIf="tierType === 'green'|| (tierType === 'welcome' && isLoggedInUser)">
                <img src="assets/icon/green-dots.svg" alt="right-leaf">
            </span>
            <span class="right-leaf" *ngIf="tierType === 'gold' || (tierType === 'welcome' && !isLoggedInUser)">
                <img src="assets/images/dots_gold.svg" alt="right-leaf">
            </span>
        </section>
        <div class="card">
            <mat-card class="faq-section">
                <div class="container">
                    <div class="row">
                        <div class="col-md-12 category-sec" *ngFor="let item of profileItems">
                            <mat-list (click)="profileListGA(item.displayName)" [routerLink]="item.routeName">
                                <a mat-list-item class="faq-list">
                                    <img src="{{item?.iconName}}" class="faq-Icon" />
                                    <span class="category-title"> {{ item?.displayName }}</span>
                                </a>
                            </mat-list>
                            <img src="assets/icon/arrow_right.svg" class="arrow-right" />
                        </div>
                        <div class="logout-sec" *ngIf="isLoggedInUser">
                            <a class="faq-list">
                                <img src="assets/icon/logout.svg" class="faq-Icon" width="30px" />
                                <span class="category-title" (click)="userLogout();logOutGA()"> LOG OUT</span>
                            </a>
                        </div>
                    </div>
                    <!-- <div class="conatiner refer-blk" *ngIf="isMobile">
                        <app-refer-you-friend *ngIf="isLoggedInUser && viewData?.referralCode"></app-refer-you-friend>
                    </div> -->
                </div>
            </mat-card>
        </div>
    </div>
    <div class="profile-blk profile-shimmer-wrap gold-tier" *ngIf="showProfileShimmer">
        <div class="tier-section">
            <span class="left-leaf">
                <img src="assets/images/leaf_gold.svg" alt="left-leaf">
            </span>
            <div class="container card-tier shimmer-wrap">
                <div class="row dp-blk">
                    <div class="col-5 col-md-4 4 d-none d-sm-block"></div>
                    <div class="col-12 col-md-4">
                        <div class="group-gap">
                            <div class="avatar-upload avatar-shimmer animate">
                                <div class="avatar-preview avatar-preview-shimmer">
                                    <div id="imagePreview imagePreview-shimmer"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-5 col-md-4 4 d-none d-sm-block text-right icons-set">
                        <img class="me-3" src="assets/icon/notification_icon_unread.svg" alt="notification_icon">
                        <img src="assets/icon/settings_icon.svg" alt="settings_icon">
                    </div>
                </div>
                <div class="row dp-blk">
                    <div class="col-4"></div>
                    <div class="col-md-4 content">
                        <div class="shimmer-btn-wrap">
                            <h2 class="card-title-shimmer animate"></h2>
                            <p class="tier-shimmer animate"></p>
                        </div>
                    </div>
                    <div class="col-4"></div>
                </div>
            </div>
            <span class="right-leaf">
                <img src="assets/images/dots_gold.svg" alt="right-leaf">
            </span>
        </div>
        <div class="card">
            <mat-card class="faq-section shimmer-wrap">
                <div class="container">
                    <div class="row">
                        <div class="col-md-12 category-sec" *ngFor="let item of [0,1,2,3,4,5];let index=index">
                            <mat-list>
                                <a mat-list-item class="faq-list">
                                    <p class="img-shimmer-wrap animate"></p>
                                    <p class="category-title-shimmer animate" [ngClass]="index%2 == 0 ? 'w-30' : 'w-10'"></p>
                                </a>
                            </mat-list>
                            <img src="assets/icon/left_shimmer_arrow.svg" class="arrow-right" />
                        </div>
                    </div>
                </div>
            </mat-card>
        </div>
    </div>
    <!-- <ng-container *ngIf="!isMobile">
        <app-footer-bar [footerData]="footerContent"></app-footer-bar>
      </ng-container> -->
</div>
